import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from "../../shared";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class AlgAuthenticationService extends BaseApiTemplateService<any>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_MODULE + 'authentication';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_MODULE + 'authentication';
    this.httpClient = http;
  }

  getAiLedgerToken(visa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }

}